import BILLING_API from 'api/billing/v1'
import GridSpinner from 'components/UI/GridSpinner'
import AutoReplenishForm from 'modules/Forms/AutoReplenish'
import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'

const AutoReplenish = () => {
  const {
    params: { accountId },
  } = useRouteMatch()

  const [currentSettings, setCurrentSettings] = useState()

  useEffect(() => {
    BILLING_API.fetchAutoReplenishSettings({ accountId }).then(
      ({ response, error }) => {
        if (error || response?.data?.auto_replenishment_available === false) {
          global.history.go(-1)
        } else {
          setCurrentSettings(response.data)
        }
      },
    )
  }, [])

  return !currentSettings ? (
    <GridSpinner />
  ) : (
    <AutoReplenishForm
      accountId={accountId}
      currentSettings={currentSettings}
      initialValues={{
        wallet: null,
        login: '',
        wallet_id: currentSettings.selected_wallet_id,
        min_balance_trigger: currentSettings.min_balance_trigger,
        auto_replenishment_amount: currentSettings.auto_replenishment_amount,
        month_limit: currentSettings.month_limit,
        is_auto_replenishment_active: currentSettings.auto_replenishment_active,
      }}
    />
  )
}

export default AutoReplenish
